import { DecodedValueMap } from "serialize-query-params/src/types";
import {
  ArrayParam,
  BooleanParam,
  encodeQueryParams,
  NumberParam,
  QueryParamConfigMap,
  StringParam,
  useQueryParams,
} from "use-query-params";

const params = {
  q: StringParam,
  page: NumberParam,
  ttags: ArrayParam,
  ctags: ArrayParam,
};

const useFilterParams = () => useQueryParams(params);

export const encodeFilterParams = (values: Partial<DecodedValueMap<QueryParamConfigMap>>) =>
  encodeQueryParams(params, values);

export default useFilterParams;
